/* eslint-disable react/jsx-props-no-spreading */
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import { Label } from './styles';
import ButtonSelect from '../button-select';

const ButtonSelectFormField = ({
  field: { name, value },
  form: { errors, touched },
  form,
  ...props
}) => (
  <>
    {props.label && (
      <Label
        error={_.get(errors, name) && _.get(touched, name)}
      >
        {props.label}
      </Label>
    )}
    <ButtonSelect
      onChange={(key) => {
        if (props.isMulti) {
          if (_.includes(value, key)) {
            form.setFieldValue(name, _.without(value, key));
          } else {
            form.setFieldValue(name, [...value, key]);
          }
        } else {
          form.setFieldValue(name, key);
        }
      }}
      isMulti={props.isMulti}
      value={value}
      {...props}
    />
  </>
);

ButtonSelectFormField.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.any,
  }).isRequired,
  form: PropTypes.shape({
    errors: PropTypes.object,
    touched: PropTypes.object,
    setFieldValue: PropTypes.func,
  }).isRequired,
  isMulti: PropTypes.bool,
  label: PropTypes.string,
};

ButtonSelectFormField.defaultProps = {
  isMulti: undefined,
  label: '',
};

export default ButtonSelectFormField;
